import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { AccountInfo, IPublicClientApplication } from '@azure/msal-browser';
import { loginRequest, loginRequestForMsGraph } from 'src/assets/config/authConfig';
import { setMsGraphApiSession, setCrewPayApiSession } from 'src/utility/jwt';
import { toast } from 'react-toastify';
import { stringResources } from 'src/assets/config/stringResources';

export interface AuthState {
    isProcessing: boolean;
    error: boolean;
    account: AccountInfo | null;
}

const initialState: AuthState = {
    isProcessing: false,
    error: false,
    account: null
}

export const authSlice = createSlice({
    name: 'authSlice',
    initialState,
    reducers: {
        startProcessing: (state) => {
            state.isProcessing = true;
        },
        hasError: (state, action: PayloadAction<boolean>) => {
            state.isProcessing = false;
            state.error = action.payload;
        },
        updateAccountSuccess: (state, action: PayloadAction<AccountInfo | null>) => {
            state.isProcessing = false;
            state.account = action.payload;
        },
    },
});

// Reducer
export default authSlice.reducer

// Actions
export const { startProcessing, hasError, updateAccountSuccess } = authSlice.actions;

// for useSelector
export const selectAuth = (state: RootState) => state.auth as AuthState;

// ----------------------------------------------------------------------
export function login(instance: IPublicClientApplication, afterLogin: Function) {
    return async (dispatch, getState) => {
        dispatch(authSlice.actions.startProcessing());
        try {
            const crewPayApiResponse = await instance.loginPopup(loginRequest);
            setCrewPayApiSession(crewPayApiResponse.accessToken);
            const account = crewPayApiResponse.account;
            dispatch(authSlice.actions.updateAccountSuccess(account));

            const msGraphApiResponse = await instance.loginPopup(loginRequestForMsGraph);
            setMsGraphApiSession(msGraphApiResponse.accessToken);

            afterLogin();
            toast.success('Welcome ' + account?.name);
        } catch (error) {
            dispatch(authSlice.actions.hasError(true));
        }
    };
}

export function logout(instance: IPublicClientApplication) {
    return async (dispatch, getState) => {
        dispatch(authSlice.actions.startProcessing());
        try {
            dispatch(authSlice.actions.updateAccountSuccess(null));
            setMsGraphApiSession(null);
            setCrewPayApiSession(null);
            await instance.logoutRedirect();
            toast.success(stringResources.AUTH_SLICE.LOG_OUT_SUCCESS);
        } catch (error) {
            dispatch(authSlice.actions.hasError(true));
        }
    };
}

